<template>
  <el-dialog  :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" @close="resetForm">
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('米比水')" prop="rwr">
        <el-input :placeholder="$t('米比水')" v-model="formData.rwr" />
      </el-form-item>
      <el-form-item :label="$t('硬度')" prop="hardness">
        <el-input :placeholder="$t('硬度')" v-model="formData.hardness" />
      </el-form-item>

      <el-form-item :label="$t('是否推荐')" prop="recommend">
        <el-select v-model="formData.recommend">
          <el-option :label="$t('是')" value="yes" />
          <el-option :label="$t('否')" value="no" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('小贴士')">
        <el-input :placeholder="$t('小贴士')" type="textarea" :rows="4" v-model="formData.tips" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "RiceForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        rwr: "",
        hardness: "",
        recommend: "",
        tips: ""
      },
      rules: {
        rwr: {required: true, message: this.$t('请输入米比水'), trigger: 'blur'},
        hardness: {required: true, message: this.$t('请输入硬度'), trigger: 'blur'},
        recommend: {required: true, message: this.$t('请选择是否推荐'), trigger: 'change'}
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if(!valid) return;
        this.$emit("confirm", this.formData);
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 500px;
  border-radius: 10px;
}

</style>
